import { render, staticRenderFns } from "./AdmissionNoteSection.vue?vue&type=template&id=795c3eac&scoped=true"
import script from "./AdmissionNoteSection.vue?vue&type=script&lang=js"
export * from "./AdmissionNoteSection.vue?vue&type=script&lang=js"
import style0 from "./AdmissionNoteSection.vue?vue&type=style&index=0&id=795c3eac&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795c3eac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('795c3eac')) {
      api.createRecord('795c3eac', component.options)
    } else {
      api.reload('795c3eac', component.options)
    }
    module.hot.accept("./AdmissionNoteSection.vue?vue&type=template&id=795c3eac&scoped=true", function () {
      api.rerender('795c3eac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/referral-management/search/components/AdmissionNoteSection.vue"
export default component.exports